import { CellContent } from './CellContent';

export default CellContent;
